  
  <template>
    <v-app-bar color="primary" dark app elevate-on-scroll>
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"></v-img>
      </template>

      <v-app-bar-nav-icon>
        <v-icon @click="goHome()">mdi-cloud</v-icon>
      </v-app-bar-nav-icon>

      <v-app-bar-title>Nuage</v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToUser()">Users Management </v-btn>

      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToKiosks()">Kiosks Management </v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToStatistics()">Log Monocase</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToEnergyCard()">Log reconnaissance bouteille</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToDashboard()">Radar</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="getIsCurrentUserAdmin" color="blue" @click="handleToFleetOverview()">Dashboard radar</v-btn>
      <v-spacer></v-spacer>

      <v-icon>mdi-account</v-icon>
      <v-app-bar-title class="ml-1 mr-12">{{getCurrentUsername}}</v-app-bar-title>
      <v-btn color="error" @click="handleDeco()"> Disconnect </v-btn>
    </v-app-bar>
  </template>


   <script>
   import { store } from "@/models/Store.js";
export default {
  data:()=>{
    return{
      store: store,
      buttonIsShowed: store.state.isCurrentUserAdmin
      
    }
  },
  methods: {
    handleDeco: function () {
      localStorage.removeItem("jwt");
      this.isConnected = false;
      this.$router.push("/login");
    },
   
    handleToUser: function () {
      if (this.$router.history.current.name != "UsersManagement")
        this.$router.push("/users");
      else
        this.$router.push("/");
    },
    handleToStatistics: function () {
      if (this.$router.history.current.name != "StatisticsManagement")
        this.$router.push("/statistics-management");
      else
        this.$router.push("/");
    },
    handleToEnergyCard: function () {
      if (this.$router.history.current.name != "EnergyCardManagement")
        this.$router.push("/energy-card");
      else
        this.$router.push("/");
    },
    handleToKiosks: function () {
      if (this.$router.history.current.name != "KioskManagement")
        this.$router.push("/kiosks-management");
      else
        this.$router.push("/");
    },
    handleToDashboard: function () {
      if (this.$router.history.current.name != "Radar")
        this.$router.push("/radar");
      else
        this.$router.push("/");
    },
    handleToFleetOverview: function () {
      if (this.$router.history.current.name != "FleetOverview")
        this.$router.push("/fleet-overview");
      else
        this.$router.push("/");
    },
    goHome: function () {
      this.$router.push("/");
    },
    checkifConnected: function () {
      return localStorage.getItem("jwt") !== null;
    },
  },
  computed:{
    getCurrentUsername(){
      return this.store.state.currentUsername
    },
    getIsCurrentUserAdmin(){
      return this.store.state.isCurrentUserAdmin
    }
  }
};
</script>